import { common, Collection, FilterCollection } from 'plato-js-client';

export const propertyChecklistsQueryOptions = (propertyId) => ({
    queryKey: [ 'checklists', { propertyId } ],
    queryFn: async () => {
        const propertyChecklists = new FilterCollection({
            path: 'pmschecklist/property',
            object: common.PmsChecklistProperty,
        });

        propertyChecklists.addFilter('propertyid', propertyId);

        await propertyChecklists.fetch();
        return propertyChecklists.collection;
    },
    placeholderData: [],
});

export const propertyChecklistQueryOptions = (propertyId, checklistId) => ({
    queryKey: [ 'checklists', { checklistId } ],
    queryFn: async () => {
        const propertyChecklist = new common.PmsChecklistProperty(checklistId);
        await propertyChecklist.get();
        return propertyChecklist;
    },
    placeholderData: {
        json: '{}',
    },
});

export const globalChecklistQueryOptions = (checklistId) => ({
    queryKey: [ 'checklists', { checklistId } ],
    queryFn: async () => {
        const globalChecklist = new  common.PmsChecklistGlobal(checklistId);
        await globalChecklist.get();
        return globalChecklist;
    },
    placeholderData: [],
});

export const globalChecklistsQueryOptions = () => ({
    queryKey: [ 'checklists' ],
    queryFn: async () => {
        const checklists = new Collection({
            path: 'pmschecklist/global',
            object: common.PmsChecklistGlobal,
        });

        await checklists.fetch();
        return checklists.collection;
    },
    placeholderData: [],
});

export const allChecklistsQueryOptions = () => ({
    queryKey: [ 'checklists' ],
    queryFn: async () => {
        const checklists = new Collection({
            path: 'pmschecklist',
            object: common.PmsChecklist,
        });

        await checklists.fetch();
        return checklists.collection;
    },
    placeholderData: [],
});
